<template>
  <div class="multi-select-wrapper">
    <multiselect
      v-model="selectedItems"
      @remove="remove($event)"
      :options="multiselectGroups"
      v-bind="defaultConfig"
      group-values="options" 
      group-label="selectAll" 
      :group-select="true"
      track-by="name"
      label="name">
      <div>
        <template slot="tag" slot-scope="props">
          <span class="custom__tag">
            <span>{{ props.name }}</span>
            <span class="custom__remove" @click="props.remove(props.name)">❌</span>
          </span>
        </template>
      </div>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "MultiSelectWrapper",
  components: {
    Multiselect
  },
  props: ["field", "value", "disabled"],
  data() {
    return {
      defaultConfig: {
        multiple: true,
        closeOnSelect: false,
        hideSelected: true,
        preserveSearch: true,
        placeholder: "- Select -",
        preselectFirst: false,
        disabled: this.disabled,
      },
      multiselectGroups: [
          {
            selectAll: "- Select all -",
            options: this.field.Values.map(function(item) {
              return {name: item}
            })
          }
        ]
    };
  },
  mounted() {
  },
  methods: {
   	remove: function (items) {
    	if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          this.selectedItems = this.selectedItems.splice( this.selectedItems.indexOf(items[i].name), 1 );
        }
      } else {
        this.selectedItems = this.selectedItems.splice( this.selectedItems.indexOf(items.name), 1 );
      }
    }
  },
  computed: {
    selectedItems: {
      get() {         
        if (Array.isArray(this.value)) {
          return this.value.map(el => {
            return {
              name: el
            };
          });
        } else if (this.value) {
          return {name: this.value};
        }

        return this.value;
      },
      set(value) {
        const parsedValue = value.map(el => el.name);
        this.$emit("input", parsedValue);
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import "src/scss/variables";

.multi-select-wrapper {
  flex: 0 0 55%;
  width: 55%;
  @media (max-width: 767px) {
    width: 100%;
  }
  & /deep/ .multiselect {
    font-family: $main-font;
    &__content {
      max-width: 100%;
      width: 100%;
    }

    &__option {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__select {
      width: 100%;
      &:before {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-100%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-inputs/MultiSelectWrapper.vue